<template>
	<div ref="container" :class="{poweredByTCWrapper: poweredByTC}" class="scroll-container" tabindex="0"
	     v-on:keydown.left="scrollLeft"
	     v-on:keydown.right="scrollRight"
	     v-on:keydown.up="scrollUp"
	     v-on:keydown.down="scrollDown"
	     v-on:keydown.tab="shiftTabScroll"
	     @keydown.-="zoomOut"
	     @keyup.187="zoomIn"
	     @keyup.61="zoomIn"
	     @keyup.107="zoomIn"
	     @keydown.91="handleCmd($event)"
	     @keydown.93="handleCmd($event)"
	     @keydown.224="handleCmd($event)"
	>
		<scroll-bar v-if="enableScrollBars" :class="{ show: showScrollBar, active: !!Math.round(maxScrollX), alwaysShow : alwaysShowScroll }"
		            :max="maxScrollX" :thumb-size="xViewPerc" :value="scrollX" mode="horizontal" @change="onScrollChange"
		            @scrollState="handleScrollState">
			<template #thumb-content>
				<slot name="scroll-thumb-x"/>
			</template>
		</scroll-bar>
		<scroll-bar v-if="enableScrollBars" :class="{ show: showScrollBar, active: !!Math.round(maxScrollY), alwaysShow : alwaysShowScroll }" :max="maxScrollY"
		            :thumb-size="yViewPErc" :value="scrollY" mode="vertical" @change="onScrollChange"
		            @scrollState="handleScrollState">
			<template #thumb-content>
				<slot name="scroll-thumb-y"/>
			</template>
		</scroll-bar>

		<div ref="touchLayer" :class="isScrolling? 'scrolling':''" class="touch-layer">
			<div ref="content" class="scroll-item">
				<slot/>
			</div>

		</div>


		<span :class="{ 'arrow horizontal left': true, 'is-visible': leftArrowVisible && enableScrollButtons, transparency: hasTransparentNavArrows }"
		      @click="scrollLeft"></span>
		<span :class="{ 'arrow horizontal right': true, 'is-visible': rightArrowVisible && enableScrollButtons, transparency: hasTransparentNavArrows }"
		      @click="scrollRight"></span>

		<span :class="{ 'arrow vertical up': true, 'is-visible': upArrowVisible && enableScrollButtons && !hideVerticalScroll, transparency: hasTransparentNavArrows }"
		      @click="scrollUp"></span>
		<span :class="{ 'arrow vertical down': true, 'is-visible': downArrowVisible && enableScrollButtons && !hideVerticalScroll, transparency: hasTransparentNavArrows }"
		      @click="scrollDown"></span>


		<!-- <div v-if="scrollToTopVisible && enableScrollToTopButton" class="toTheTop" @click="scrollToTop"/> -->
		<span v-if="this.language === 'en'">
      <transition name="scroll-top-btn">
        <div v-if="scrollToTopVisible && enableScrollToTopButton" class="toTheTop" :class="{ 'scrollbar-visible': showScrollBar }" @click="scrollToTop"/>
      </transition>
    </span>
		<span v-else>
      <transition name="scroll-top-btn">
        <div v-if="scrollToTopVisible && enableScrollToTopButton" class="toTheTopFr" :class="{ 'scrollbar-visible': showScrollBar }" @click="scrollToTop"/>
      </transition>
    </span>
		<PoweredByTC v-if=" poweredByTCVisible"/>
 <!-- Screen reader announcement -->
    <div
      class="page-announcer"
  role="status"
  aria-live="assertive"
  aria-atomic="true"
    >
     <span :key="currentPageNumber">
    {{ liveAnnouncement }}
  </span>
    </div>
	</div>
</template>

<script>

import ScrollContentObserverMixin from "@/components/scroll-container/ScrollContentObserverMixin";

const mounted = [];

import ScrollZoom from "@/classes/ScrollZoom";
import ScrollBar from "@/components/scroll-container/ScrollBar";

import PoweredByTC from "@/components/buttons/PoweredByTC.vue"
import {mapActions, mapGetters, mapState} from "vuex";
import Lytics from "../../classes/Lytics";

export default {
	name: "ScrollContainer",
	components: {ScrollBar, PoweredByTC},
	mixins: [ScrollContentObserverMixin],
	props: {
		orientation: {
			type: String,
			default: () => {
				return 'horizontal'
			}
		},
		maxWidth: {
			type: Number,
			default: () => {
				return 900
			}
		},
		align: {
			type: String,
			default: () => {
				return 'center'
			}
		},
		zoomLevel: {
			type: Number,
			default: () => {
				return 0;
			}
		},
		syncGlobalZoom: {
			type: Boolean,
			default: true
		},
		scale: {
			type: [Number, String],
			default: null
		},
		fitAxis: {
			type: String,
			default: () => {
				return null;
			}
		},
		enableScrollBars: {
			type: Boolean,
			default: true
		},
		enableScrollButtons: {
			type: Boolean,
			default: true
		},
		enableScrollToTopButton: {
			type: Boolean,
			default: true
		},
		scrollBarAutoSize: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			maxScrollX: 0,
			maxScrollY: 0,
			scrollX: 0,
			scrollY: 0,
			isScrolling: false,
			showScrollBar: false,
			contentHeight: 0,
			contentWidth: 0,
			viewHeight: 0,
			viewWidth: 0,
			tid: null,
			timeout: null,
			tabDirection: 1,
			liveAnnouncement: ""
		}
	},
	mounted() {
		mounted.push(this);

		this._sz = new ScrollZoom(this);
		this._sz.fitAxis = this.fitAxis;
		this._sz.zoom = this.zoomLevel;
		this._sz.maxWidth = this.maxWidth;
		this._sz.align = this.align;

		this.contentHeight = this._sz.content.offsetHeight;
		this.contentWidth = this._sz.content.offsetWidth;

		this.viewHeight = this._sz.getViewHeight();
		this.viewWidth = this._sz.getViewWidth();

		this.$refs.content.addEventListener('transitionend', (e) => {

			if (e.target == this.$refs.content) {
				this.$emit('change', this);
			}

		})

		this._sz.update();
		//this.updateScale(this._sz.getScale());

		//This part is added for maintain arrow position while moving by Tab
		this.$refs.container.addEventListener('scroll', () => {
			const isSearch = this.showSearchResults;
			const isVertical = this.flyerOrientation === 'vertical';
			const nextPageIndex = this.currentPageIndex + 1;
			if (isVertical) {
				if (!isSearch) {
					this.$root.$emit('trigger-scroll-to-index', nextPageIndex);
					this.$refs.container.scrollTop = 0;
				} else {
					this.scroll({'+y': -300});
					this.$refs.container.scrollTop = 0;
				}
			} else {
				if (!isSearch) {
					this.$root.$emit('trigger-scroll-to-index', nextPageIndex);
					this.$refs.container.scrollLeft = 0;
				} else {
					this.scroll({'+x': -300});
					this.$refs.container.scrollLeft = 0;
				}
			}
		});


		setTimeout(() => {
			this.scroll({y: 0, x: 0});
			this.$emit('ready', this);
		}, 10)


		//console.log('Mounted ScrollContainers:', mounted);
	},

	beforeDestroy() {
		const index = mounted.findIndex((item) => {
			return item._uid == this._uid
		})
		if (index >= 0) {
			mounted.splice(index, 1)
		}

		this._sz.destroy();
		//console.log('UnMounted ScrollContainers:', mounted);
	},

	methods: {
		...mapActions('scale', ['zoomIn', 'zoomOut', 'updateScale', 'setZoomLevel', 'setScrollY', 'updateScrollX', 'setManualZoom']),
		...mapActions('screen', ['handleWindowResize']),
		...mapActions(['setCurrentPageIndex']),

		shiftTabScroll(e) {
			this.tabDirection = e.shiftKey ? -1 : 1;
			if (this.tabDirection === -1) { // only for Shift+Tab
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						const focused = document.activeElement;
						const container = this.$refs.touchLayer;
						if (!focused || !container || !container.contains(focused)) return;
						const f = focused.getBoundingClientRect();
						const c = container.getBoundingClientRect();
						const isVertical = this.flyerOrientation === 'vertical';
						let dx = 0, dy = 0;
						if (isVertical) {
							if (f.top < c.top) dy = f.top - c.top;
							else if (f.bottom > c.bottom) dy = f.bottom - c.bottom;
							const maxStep = 320; // tweak
							dy = Math.max(-maxStep, Math.min(maxStep, dy));
						} else {
							// horizontal
							if (f.left < c.left) dx = f.left - c.left;
							else if (f.right > c.right) dx = f.right - c.right;
						}
						if (dx !== 0 || dy !== 0) {
							this._sz.transform.x -= dx;
							this._sz.transform.y -= dy;
							this._sz.applyTransform();
							this.$refs.container.scrollLeft = 0;
							this.$refs.container.scrollTop = 0;
						}
					});
				});
			}
		},

		handleCmd(e) {
			console.log("called handleCmd, you presed", e.keyCode);
			if (e.keyCode == 187 && e.metaKey) {
				console.log("pressed command + key on mac", e.keyCode);
				this.zoomIn();
			} else if ((e.keyCode == 189 && e.metaKey)) {
				console.log("pressed command - key on mac", e.keyCode);
				this.zoomOut();
			}
		},

		onChange(scroller, events) {
			//console.log('ScrollContainer Event:', scroller)
			this.maxScrollX = scroller.getScrollMaxX();
			this.maxScrollY = scroller.getScrollMaxY();
			this.scrollX = scroller.getScrollX();
			this.scrollY = scroller.getScrollY();

			this.contentHeight = this._sz.content.offsetHeight;
			this.contentWidth = this._sz.content.offsetWidth;

			this.viewHeight = this._sz.getViewHeight();
			this.viewWidth = this._sz.getViewWidth();

			if (events.touchstart) {
				this.isScrolling = true;
			}

			if (this.isScrolling) {
				delete events.resize;
			}

			if (events.touchend) {
				this.isScrolling = false;
			}

			if (events.wheelScroll) {
				// const e = events.wheelScroll;
				// const pr = window.devicePixelRatio;
				// console.log((Math.abs(e.deltaX) > pr) || (Math.abs(e.deltaY) > pr))
				// console.log('Wheel Scroll:', events.wheelScroll);
				// this.isScrolling = (Math.abs(e.deltaX) > pr) || (Math.abs(e.deltaY) > pr);
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.isScrolling = false;
				}, 250);
				this.isScrolling = true;
			}

			if (events.momentum) {
				this.isScrolling = true;
			}


			this.$emit('change', this);

			for (let p in events) {
				this.$emit(p, this);
				switch (p) {
					case 'resize': {
						const screenWidth = window.innerWidth;
						const zoomFactor = Math.pow(screenWidth / 1920, 10)
						const calculatedZoom = Math.max(0, Math.min(0.25, zoomFactor * 0.25));
						if (!this.manualZoom) {
							if (this.flyerOrientation === 'vertical' && this.displayMode === 'desktop' && this.flyerDrawer) {
								this.setZoomLevel(calculatedZoom);
							}
						}
						//TODO - Investigate why this was needed, (removed to see what breaks)
						//this.handleWindowResize();
						break;
					}
					case 'zoom':
						//this.setZoomLevel(this._sz.zoom);
						break;
					case 'pinchend':
						// console.log('Pinch End Updating Scale')
						if (this.syncGlobalZoom) this.setZoomLevel(this._sz.zoom);
						this._sz.zoom = this.zoomLevel;
						this._sz.update();
						this.updateScale(this._sz.getScale());
						this.updateScrollX(this._sz.getScrollX());
						break;
					case 'touchend':
						if (this.displayMode === 'desktop') {
							if (this.syncGlobalZoom) this.setZoomLevel(this._sz.zoom);
						}
						break;
				}
			}
			this.showScrollBar = true;
			clearTimeout(this.scrollBarTimeoutID);
			this.scrollBarTimeoutID = setTimeout(() => {
				this.showScrollBar = false;
			}, 500);

			if (!this.additionalItemInputFocus && !this.emailInputFocus && !this.showSideBar) {
				// this.focus();
			}

			//console.log('maxScrollY:', this.maxScrollY, '   scrollY:', this.scrollY)

		},

		onScrollContainerZoom(scroller) {
			if (this.syncGlobalZoom) this.setZoomLevel(scroller.zoom);
		},

		onScrollChange(delta) {
			//console.log('onScrollChange Delta:', delta);
			this._sz.applyTransform(delta);
		},

		eventScroll(scroll, e) {
			if (e.key === 'ArrowDown' && this.scrollY !== 0) {
				this.setScrollY(this.scrollY)
			}

			const prevent = () => {
				e.stopPropagation();
				e.preventDefault();
				e.returnValue = false;
				return false;
			}
			this.scroll(scroll);
			if (this.scrollY != 0 && this.scrollY != this.maxScrollY) {
				return prevent();
			}
		},

		scroll(scroll) {
			this._sz.velocity = null;
			this.isScrolling = false;
			this._sz.applyTransform(scroll);
		},
		getScroll() {
			return {x: this._sz.getScrollX(), y: this._sz.getScrollY()};
		},
		getController() {
			return this._sz;
		},
		getMaxScroll() {
			return {x: this._sz.getScrollMaxX(), y: this._sz.getScrollMaxY()};
		},

		handleScrollState(state) {
			//console.log('handleScrollState:', state)
			this._sz.enabled = !state;
			this.isScrolling = state;
			this.$emit('scrollState', state);

			//this.$refs.container.focus();

		},

		scrollLeft() {
			Lytics.TriggerScrollButtonClick({
				orientation: 'horizontal',
				page_number: this.currentPageNumber,
				scroll_direction: 'backward'
			});

			if (this.features.scroll?.isFullPageScroll && !this.showSearchResults) {
				this.$nextTick(() => {
				// Handle half-page flyers correctly by finding the nearest previous rendered page
				// instead of relying only on currentPageIndex - 1
				const containerRect = this.$refs.container.getBoundingClientRect();

				const pages = Array.from(
					this.$refs.content.querySelectorAll('[index]')
				);

				const currentOrPrevious = pages
					.map(el => ({
					el,
					index: Number(el.getAttribute('index')),
					rect: el.getBoundingClientRect()
					}))
					.filter(page => page.rect.left < containerRect.left - 5)
					.sort((a, b) => b.rect.left - a.rect.left)[0];

				if (!currentOrPrevious) {
					this.scroll({ x: 0 });
					return;
				}

				this.$root.$emit('trigger-scroll-to-index', currentOrPrevious.index);
				});

				return;
			}

			this.scroll({ '+x': 300 });
			},
		scrollRight() {
			Lytics.TriggerScrollButtonClick({
				orientation: 'horizontal',
				page_number: this.currentPageNumber,
				scroll_direction: 'forward'
			})
			if (this.features.scroll?.isFullPageScroll && !this.showSearchResults) {
				this.$nextTick(() => {
				const nextPageIndex = this.currentPageIndex + 1;
				this.$root.$emit('trigger-scroll-to-index', nextPageIndex);
				})
			} else {
				this.scroll({'+x': -300});
			}
		},

		scrollUp() {
			if (this.features.scroll?.isFullPageScroll) {
				this.scroll({'+y': 550});
			} else {
				this.scroll({'+y': 300});
			}
			Lytics.TriggerScrollButtonClick({
				orientation: 'vertical',
				page_number: this.currentPageNumber,
				scroll_direction: 'backward'
			})
		},

		scrollDown() {
			if (this.features.scroll?.isFullPageScroll) {
				this.scroll({'+y': -550});
			} else {
				this.scroll({'+y': -300});
			}

			this.setScrollY(this.scrollY + 250)
			Lytics.TriggerScrollButtonClick({
				orientation: 'vertical',
				page_number: this.currentPageNumber,
				scroll_direction: 'forward'
			})
		},


		scrollToTop() {
			this.scroll({y: 0});
		},

		focus() {
			this.$refs.container.focus();
			// console.log('flyer focussed')
		},

		getContainerDom() {
			return this.$refs.container;
		}


	},
	computed: {
		//...mapState('scale', ['zoomLevel']),
		...mapState('scale', ['zoomMin', 'zoomMax', 'manualZoom', 'curentScale']),
		...mapState(['searchInputFocused', 'showSideBar', 'currentPageNumber', 'currentPageIndex']),
		...mapState('shoppingList', ['additionalItemInputFocus', 'emailInputFocus']),
		...mapState(['columnView', 'currentStore', 'pdf']),
		...mapGetters(['language']),
		...mapGetters('search', ['showSearchResults']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('config', ['branding', 'features', "rootStyle"]),

		poweredByTCVisible() {
			let isPoweredByTC = this.features?.poweredByTC?.enabled
			return isPoweredByTC && this.scrollY >= this.maxScrollY - 5 && this.flyerOrientation == 'vertical'
		},
		poweredByTC() {
			let isPoweredByTC = this.features?.poweredByTC?.enabled
			return isPoweredByTC && this.flyerOrientation == 'vertical'
		},
		alwaysShowScroll() {
			return this.features?.scroll?.alwaysShowScroll ?? false;
		},
		hasTransparentNavArrows() {
			return (this.features?.navigationArrows?.transparent) ?? true;
		},
		/*fitAxis() {
		  return this.orientation == 'horizontal' ? 'y' : 'x';
		},*/


		leftArrowVisible() {
			this.$root.$emit((this.scrollX === 0 ? 'hide-arrow' : 'show-arrow'), 'left')
			return this.scrollX > 0 && this.maxScrollX;
		},

		rightArrowVisible() {
			this.$root.$emit((this.scrollX < Math.floor(this.maxScrollX) ? 'show-arrow' : 'hide-arrow'), 'right')
			return this.scrollX < Math.floor(this.maxScrollX);
		},

		upArrowVisible() {
			this.$root.$emit((this.scrollY === 0 ? 'hide-arrow' : 'show-arrow'), 'up')
			return this.scrollY > (1 / devicePixelRatio);
		},

		downArrowVisible() {
			this.$root.$emit((this.scrollY < Math.ceil(this.maxScrollY - 1) ? 'show-arrow' : 'hide-arrow'), 'down')
			return (this.scrollY < Math.ceil(this.maxScrollY) - 1);
		},

		scrollToTopVisible() {
			return this.scrollY > 0 && this.orientation == 'vertical';
		},

		xViewPerc() {
			return (this.viewWidth / this.contentWidth) * 100;
		},
		yViewPErc() {
			return (this.viewHeight / this.contentHeight) * 100;
		},
		flyerDrawer() {
			return this.features.flyerSelector._flyerOrientation['+vertical']?.['_display']?.['+desktop']?.position === 'left';
		},
		hideVerticalScroll() {
			return this.features?.scroll?.hideVerticalScroll ?? false;
		}

	},

	watch: {
		orientation() {
			this._sz.fitAxis = this.fitAxis;
			if (this.flyerOrientation === 'vertical' && this.displayMode === 'desktop') {
				this.setManualZoom(false)
				this.setZoomLevel(this.zoomLevel)
			} else {
				this.setZoomLevel(0)
			}
			// this.setZoomLevel(this.zoomLevel)
			/*if(val == 'horizontal'){
			  this._sz.setScrollX( -this.scrollY )
			} else {
			  this._sz.setScrollY( -this.scrollX )
			}*/
			this._sz.update();

		},
		displayMode() {
			if (this.displayMode !== 'desktop') {
				this.setZoomLevel(0)
			}
		},
		zoomLevel(val) {
			//console.log('Watch Zoom Level', val)
			this._sz.zoom = val;
			this._sz.update();
			//this.updateScale(this._sz.getScale());
		},
		maxWidth(val) {
			this._sz.maxWidth = val;
			this._sz.update();
		},
		// searchInputFocused(val){
		//   if(!val){
		//     this.focus();
		//   }
		// },
		align(val) {
			this._sz.align = val;
			this._sz.update();
		},
		currentPageNumber(newPage) {
			this.liveAnnouncement = `Flyer page ${newPage}`;
		},
				}

}
</script>

<style scoped>
.scroll-container:focus {
	outline: none;
}

.page-announcer {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}

.scroll-container {
	min-height: 10px;
}

.scroll-container.poweredByTCWrapper {
	padding-bottom: 25px !important;
}

.toTheTop {
	display: block;
	width: 90px;
	height: 90px;
	background: url('/images/back-tothe-top-mobile.png') no-repeat center 45%;
	background-size: 77% auto;
	position: absolute;
  right: 0;
	bottom: 20px;
	cursor: pointer;
	filter: drop-shadow(2px 4px 6px black);
	opacity: 0.9;
	cursor: pointer;
	z-index: 5;
  transition: right 0.3s;
  transition-delay: 2s;
}

.toTheTop.scrollbar-visible {
  right: 15px;
  transition-delay: 0s;
}

.toTheTopFr {
	display: block;
	width: 90px;
	height: 90px;
	background: url('/images/back-tothe-top-mobile-fr-png.png') no-repeat center 45%;
	background-size: 68% auto;
	position: absolute;
  right: 0;
	bottom: 20px;
	cursor: pointer;
	filter: drop-shadow(2px 4px 6px black);
	opacity: 0.9;
	cursor: pointer;
	z-index: 5;
  transition: right 0.3s;
  transition-delay: 2s;
}

.toTheTopFr.scrollbar-visible {
  right: 15px;
  transition-delay: 0s;
}

.scroll-top-btn-enter-active,
.scroll-top-btn-leave-active {
  transition: opacity 0.3s;
}

.scroll-top-btn-enter,
.scroll-top-btn-leave-to {
  opacity: 0;
}

@media screen and (max-width: 628px) {
	.scroll-container.poweredByTCWrapper {
		padding-bottom: 30px !important;
	}

	.arrow {
		display: none;
	}

	.scroll-bar.horizontal {
		display: none;
	}
}

@media screen and (min-width: 628px) {

	.toTheTop {
		display: none;
	}

	.toTheTopFr {
		display: none;
	}
}

@media screen and (min-width: 1256px) {
	.toTheTop {
		display: none;
	}

	.toTheTopFr {
		display: none;
	}
}

.arrow {
	position: absolute;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	opacity: 1;
	transition: opacity 200ms, filter 100ms;
	/*box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.5);*/
	filter: drop-shadow(0px 0px 0px #222);
	cursor: pointer;
	display: none;
}

.arrow.transparency {
	opacity: 0.4 !important;
}

.arrow.is-visible {
	display: block;
}

.arrow.transparency:hover {
	opacity: 0.9 !important;
	filter: drop-shadow(3px 2px 3px #222);
}

.arrow:active {
	filter: drop-shadow(0px 0px 0px #222);
}

.arrow.horizontal {
	top: 50%;
	transform: translateY(-50%);
}

.arrow.vertical {
	left: 50%;
	transform: translateX(-50%);
	touch-action: none;
}

.arrow.left {
	background-image: url("/images/moveleft-arrow-desktop.png");
	left: 35px;
}

.arrow.right {
	background-image: url("/images/moveright-arrow-desktop.png");
	right: 35px;
}

.arrow.up {
	background-image: url("/images/moveleft-arrow-desktop.png");
	transform: rotate(90deg) translateY(-50%);
	transform-origin: top left;
	top: 35px;
}

.arrow.down {
	background-image: url("/images/moveleft-arrow-desktop.png");
	transform: rotate(-90deg) translateY(50%);
	transform-origin: bottom left;
	bottom: 35px;
}

.scroll-container {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
}

.scroll-item {
	width: max-content;
	height: max-content;
	transform: translateZ(0px);
	transition: transform 0.3s;
	transform-origin: top left;
}

.scrolling .scroll-item {
	transition: none;
	pointer-events: none;
	touch-action: none;
}

.scroll-container * {
	-webkit-backface-visibility: hidden;
}

.touch-layer {
	position: relative;
	left: 0px;
	right: 0px;
	top: 0px;
	bottom: 0px;
	height: 100%;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
